// Thư mục: src/stores/hoSoXeStore.js
import { defineStore } from "pinia";
import { HoSoXeApi } from "@/services/hoSoXeService";

export const useHoSoXeStore = defineStore("hoSoXe", {
  state: () => ({
    isLoading: false,
    error: null,
    // State chứa toàn bộ hồ sơ trả về từ API
    hoSo: {
      xeHienTai: null, // Thông tin xe
      taiXe: null, // Thông tin tài xế (NguoiDungResponse)
      danhSachGiayTo: [], // List GiayToResponse
    },
  }),

  getters: {
    // Getter để tách riêng giấy tờ xe và giấy tờ tài xế cho tiện
    giayToXe(state) {
      return state.hoSo.danhSachGiayTo?.filter((gt) => gt.xeId) || [];
    },
    giayToTaiXe(state) {
      return state.hoSo.danhSachGiayTo?.filter((gt) => gt.nguoiDungId) || [];
    },
    // Getter kiểm tra xem có hồ sơ hay chưa
    hasHoSo(state) {
      return !!state.hoSo.taiXe; // Kiểm tra có thông tin tài xế là đủ
    },
  },

  actions: {
    // Action để gọi API lấy hồ sơ
    async fetchHoSoCuaToi() {
      this.isLoading = true;
      this.error = null;
      this.hoSo = { xeHienTai: null, taiXe: null, danhSachGiayTo: [] }; // Reset trước khi fetch

      try {
        const data = await HoSoXeApi.getHoSoCuaToi();
        this.hoSo = data || {
          xeHienTai: null,
          taiXe: null,
          danhSachGiayTo: [],
        };
      } catch (e) {
        // Xử lý các lỗi cụ thể từ API (401, 403, 404...)
        if (e?.response?.status === 401) {
          this.error = "Phiên đăng nhập hết hạn hoặc không hợp lệ.";
          // Có thể redirect về trang login ở đây
        } else if (e?.response?.status === 403) {
          this.error =
            "Bạn không có quyền truy cập chức năng này (Không phải tài xế?).";
        } else if (e?.response?.status === 404) {
          this.error =
            e?.response?.headers?.["x-error-message"] ||
            "Không tìm thấy hồ sơ xe hoặc bạn chưa được phân công xe.";
        } else {
          this.error =
            e?.response?.data?.message ||
            e?.message ||
            "Lỗi không xác định khi tải hồ sơ xe.";
        }
        console.error("fetchHoSoCuaToi error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    // Action để xóa/reset hồ sơ khi logout
    clearHoSo() {
      this.hoSo = { xeHienTai: null, taiXe: null, danhSachGiayTo: [] };
      this.error = null;
    },
  },
});
